export default __webpack_public_path__ + "static/media/no-bonus.f33e59a9.svg";